<script>
export default {
  render() {
    return <ul class={this.$style.root}>{this.$slots.default}</ul>
  }
}
</script>

<style lang="scss" module>
.root {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: -0.5rem;
}
</style>
